module.exports = __webpack_public_path__ + "static/media/ully.43330a9b.svg";